import enquire from 'enquire-js';
import { toggleClass, toggleAttribute } from '../helpers';

const init = () => {
	const contactMenuColumn = document.querySelector(
		'.wp-block-contact-us-callout__menu-column'
	);
	const contactMenu = document.querySelector(
		'.wp-block-contact-us-callout__menu-column .menu'
	);
	const menuTitle = document.querySelector('.wp-block-contact-us-callout__menu-title');
	const content = document.querySelector('.wp-block-contact-us-callout__content-text');
	const contactMenuContainer = document.querySelector(
		'.wp-block-contact-us-callout > .columns'
	);

	if (!contactMenuColumn) {
		return;
	}

	let menuOpen = false;

	// Handle the toggling of the Quick Links menu
	// toggles visibility of menu and aria attributes
	// of button and menu
	function toggleMenuOpen() {
		toggleClass(document.body, '-contact-menu-open');
		toggleAttribute(contactMenu, 'aria-hidden');
		toggleAttribute(menuTitle, 'aria-expanded');
		menuOpen != menuOpen;
	}

	menuTitle.addEventListener('click', toggleMenuOpen);

	/**
	 * Rearrange the dom on mobile,
	 * putting the Quick Links menu below the content area
	 */
	enquire.register('screen and ( max-width: 767px )', {
		match: () => {
			content.insertAdjacentElement('afterend', contactMenuColumn);
			menuTitle.setAttribute('role', 'button');
			menuTitle.setAttribute('aria-expanded', false);
			contactMenu.setAttribute('aria-hidden', true);
		},
		unmatch: () => {
			contactMenuContainer.insertAdjacentElement('afterbegin', contactMenuColumn);
			menuTitle.setAttribute('role', 'heading');
		}
	});
};

init();
